import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Los font-size custom del design system (`text-13`, `text-2xs`, etc.) no los
// conoce tailwind-merge por defecto: los clasifica como si fueran utilidades
// de color (`text-*`) y entran en conflicto con colores reales como
// `text-brand-contrast`. Cuando el size va después del variant en cn(),
// twMerge descartaba el color → botones primary `md` con letra oscura sobre
// fondo de marca. Registrándolos en el grupo `font-size` se resuelve: el
// tamaño solo entra en conflicto con otros tamaños, nunca con el color.
//
// Mismo problema con el resto de tokens propios (globals.css, `@theme`): sin
// registrarlos, `shadow-sm shadow-focus`, `z-sticky z-modal` o
// `duration-med duration-fast` conservaban LAS DOS clases y ganaba la que
// estuviera despues en el CSS, no la ultima escrita (revision de
// dependencias, 2026-10-01).
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['3xs', '2xs', '12', '13', '14', '15', '16', '18', '20', '24'] }],
      shadow: [{ shadow: ['focus', 'focus-error', 'focus-ok', 'focus-warning'] }],
      z: [
        {
          z: [
            'base',
            'dropdown',
            'sticky',
            'overlay',
            'modal',
            'popover',
            'toast',
            'tooltip',
            'skip',
          ],
        },
      ],
      duration: [{ duration: ['fast', 'med', 'slow', 'entering'] }],
      ease: [{ ease: ['smooth', 'snappy'] }],
      animate: [
        {
          animate: [
            'fade-in',
            'fade-out',
            'float',
            'float-slow',
            'pulse-soft',
            'scale-in',
            'scale-out',
            'shimmer',
            'slide-down',
            'slide-up',
            'slide-in-bottom',
            'slide-in-left',
            'slide-in-right',
            'slide-out-bottom',
            'slide-out-left',
            'slide-out-right',
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
